/**
 * Request body for `POST /api/sales-contact-requests` (MVP-9).
 * Mirrors the backend `SalesContactRequestDto`.
 */
export interface ISalesContactRequest {
  fullName: string;
  billingDepartment: string;
  billingStreet: string;
  billingZip: string;
  billingCity: string;
  billingCountryId: number;
  invoicingEmail: string;
  message?: string;
}

/**
 * Success payload returned on 201 Created from `POST /api/sales-contact-requests`.
 */
export interface ISalesContactResponse {
  id: string;
}

/**
 * Stable backend error codes surfaced by the sales-contact endpoint.
 * Used by the frontend to branch on specific failure modes (e.g. ACS down).
 */
export const SALES_CONTACT_ERROR_CODES = {
  VALIDATION_FAILED: 'salesContact.validation_failed',
  EMAIL_FAILED: 'salesContact.email_failed',
} as const;
